export interface NewsItem {
  label: string;
  date: string;
  category: string;
  to?: string;
  href?: string;
  isNew: boolean;
}

export const newsItems: NewsItem[] = [
  {
    label: "ガス腐食試験無料体験サービスのご案内",
    date: "2026.07.07",
    category: "サービス",
    to: "/service/free-trial",
    isNew: true,
  },
  {
    label: "銅クーポン ガス腐食試験結果報告書を公開しました",
    date: "2026.06.30",
    category: "レポート",
    href: "https://www.factk.jp/factk/pdf/Report_CopperCoupon.pdf",
    isNew: true,
  },
  {
    label: "アルファミスト販売終了のお知らせ",
    date: "2026.04.01",
    category: "お知らせ",
    href: "https://www.factk.jp/factk/pdf/discontinued_alfamist.pdf",
    isNew: true,
  },
  {
    label: "ガス腐食試験管理基準について",
    date: "2025.02.01",
    category: "技術情報",
    href: "https://www.factk.jp/factk/pdf/CorrosionTestStandardofConduct.pdf",
    isNew: false,
  },
  {
    label: "ISO/IEC17025認定取得について",
    date: "2021.12.18",
    category: "お知らせ",
    href: "https://www.factk.jp/factk/pdf/iso17025.pdf",
    isNew: false,
  },
];

export const newsCategories = ["すべて", "お知らせ", "製品", "サービス", "レポート", "技術情報", "イベント"];